module.exports = __webpack_public_path__ + "img/selected0-min.34af0b28.png";